<template>
  <div class="completed-step">
    <svg
      :width="sizeClasses[size]"
      :height="sizeClasses[size]"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_32793_99658)">
        <path
          d="M0 16C0 7.16344 7.16344 0 16 0C24.8366 0 32 7.16344 32 16C32 24.8366 24.8366 32 16 32C7.16344 32 0 24.8366 0 16Z"
          fill="#F9F5FF"
        />
        <path
          d="M16 1C24.2843 1 31 7.71573 31 16C31 24.2843 24.2843 31 16 31C7.71573 31 1 24.2843 1 16C1 7.71573 7.71573 1 16 1Z"
          fill="#7F56D9"
        />
        <path
          d="M16 1C24.2843 1 31 7.71573 31 16C31 24.2843 24.2843 31 16 31C7.71573 31 1 24.2843 1 16C1 7.71573 7.71573 1 16 1Z"
          stroke="#7F56D9"
          stroke-width="2"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M22.7934 9.85029L13.2467 19.0636L10.7134 16.357C10.2467 15.917 9.51339 15.8903 8.98005 16.2636C8.46005 16.6503 8.31338 17.3303 8.63338 17.877L11.6334 22.757C11.9267 23.2103 12.4334 23.4903 13.0067 23.4903C13.5534 23.4903 14.0734 23.2103 14.3667 22.757C14.8467 22.1303 24.0067 11.2103 24.0067 11.2103C25.2067 9.98362 23.7534 8.90362 22.7934 9.83696V9.85029Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_32793_99658">
          <path
            d="M0 16C0 7.16344 7.16344 0 16 0C24.8366 0 32 7.16344 32 16C32 24.8366 24.8366 32 16 32C7.16344 32 0 24.8366 0 16Z"
            fill="white"
          />
        </clipPath>
      </defs>
    </svg>
  </div>
</template>

<script setup>
import { computed } from "vue";
const props = defineProps({
  size: {
    type: String,
    default: "large",
    validator: (value) => ["small", "medium", "large"].includes(value),
  },
});

const sizeClasses = computed(() => {
  return {
    small: "24",
    medium: "32",
    large: "40",
  };
});
</script>

<style scoped></style>
